import React, { useEffect, useRef, useState } from 'react';

/**
 * PulseValue — flash discret style Bloomberg/Robinhood quand la valeur change.
 * Vert si valeur monte, rouge si elle baisse, doré sinon.
 *
 * Usage:
 *   <PulseValue value={ca}>{ca.toLocaleString()} F</PulseValue>
 *
 * Props:
 *   value      : valeur à observer (number/string)
 *   children   : ce qu'on affiche
 *   className  : classes additionnelles
 *   colorize   : si true (défaut), flash vert/rouge selon variation. Sinon flash doré.
 */
const PulseValue = ({ value, children, className = '', colorize = true }) => {
  const prev = useRef(value);
  const [flash, setFlash] = useState(null); // 'up' | 'down' | 'neutral' | null

  useEffect(() => {
    if (prev.current === undefined || prev.current === null) {
      prev.current = value;
      return;
    }
    if (value === prev.current) return;
    let dir = 'neutral';
    if (colorize && typeof value === 'number' && typeof prev.current === 'number') {
      if (value > prev.current) dir = 'up';
      else if (value < prev.current) dir = 'down';
    }
    setFlash(dir);
    const t = setTimeout(() => setFlash(null), 700);
    prev.current = value;
    return () => clearTimeout(t);
  }, [value, colorize]);

  const flashCls =
    flash === 'up' ? 'pc-pulse-up' :
    flash === 'down' ? 'pc-pulse-down' :
    flash === 'neutral' ? 'pc-pulse-neutral' : '';

  return (
    <span className={`pc-pulse ${flashCls} ${className}`}>{children}</span>
  );
};

export default PulseValue;
